export default __webpack_public_path__ + "static/media/header-bg.5e8f17b0.jpg";